import { createSlice } from '@reduxjs/toolkit';
import { initializeSuccess, initializeError } from '../actions';
import type { ErrorActionPayload } from '../actions';

export interface InitializationState {
  success: boolean;
  error: ErrorActionPayload | null;
}

const initialState: InitializationState = {
  success: false,
  error: null,
};

const initializationSlice = createSlice({
  name: 'initialization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initializeSuccess, (state) => {
        state.success = true;
      })
      .addCase(initializeError, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const initializationReducer = initializationSlice.reducer;
